import { NavLink, Outlet, useSearchParams } from 'react-router-dom';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const DEFAULT_FROM = (() => {
  const d = new Date();
  d.setDate(d.getDate() - 30);
  return d.toISOString().split('T')[0];
})();
const DEFAULT_TO = new Date().toISOString().split('T')[0];

const NAV_LINKS = [
  { to: '/analytics',          label: 'Dashboard',    end: true },
  { to: '/analytics/campaigns', label: 'Campaigns' },
  { to: '/analytics/email',     label: 'Email' },
  { to: '/analytics/funnel',    label: 'Funnel' },
  { to: '/analytics/health',    label: 'Health Check' },
  { to: '/analytics/alerts',    label: 'Alerts' },
];

export function AnalyticsLayout() {
  const [searchParams, setSearchParams] = useSearchParams();
  const from = searchParams.get('from') ?? DEFAULT_FROM;
  const to   = searchParams.get('to')   ?? DEFAULT_TO;

  const setFrom = (v: string) =>
    setSearchParams(p => { p.set('from', v); return p; }, { replace: true });
  const setTo = (v: string) =>
    setSearchParams(p => { p.set('to', v); return p; }, { replace: true });

  return (
    <div className="p-6 max-w-7xl mx-auto space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold">Analytics</h1>
          <p className="text-sm text-muted-foreground">Campaign and email sequence performance</p>
        </div>
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-1.5">
            <Label htmlFor="date-from" className="text-xs text-muted-foreground">From</Label>
            <Input
              id="date-from"
              type="date"
              value={from}
              onChange={e => setFrom(e.target.value)}
              className="h-8 w-32 text-sm"
            />
          </div>
          <div className="flex items-center gap-1.5">
            <Label htmlFor="date-to" className="text-xs text-muted-foreground">To</Label>
            <Input
              id="date-to"
              type="date"
              value={to}
              onChange={e => setTo(e.target.value)}
              className="h-8 w-32 text-sm"
            />
          </div>
        </div>
      </div>

      {/* Tab-style nav */}
      <div className="flex border-b border-border">
        {NAV_LINKS.map(link => (
          <NavLink
            key={link.to}
            to={`${link.to}?from=${from}&to=${to}`}
            end={link.end}
            className={({ isActive }) =>
              `px-3 py-2 text-sm transition-colors border-b-2 -mb-px ${
                isActive
                  ? 'font-medium text-foreground border-primary'
                  : 'text-muted-foreground hover:text-foreground border-transparent'
              }`
            }
          >
            {link.label}
          </NavLink>
        ))}
      </div>

      <Outlet />
    </div>
  );
}
